module.exports = __webpack_public_path__ + "static/media/IMG_4379.07db3e21.jpg";